import { render, staticRenderFns } from "./dialog-huanfang.vue?vue&type=template&id=1bce35b4&scoped=true&"
import script from "./dialog-huanfang.vue?vue&type=script&lang=js&"
export * from "./dialog-huanfang.vue?vue&type=script&lang=js&"
import style0 from "./dialog-huanfang.vue?vue&type=style&index=0&id=1bce35b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce35b4",
  null
  
)

export default component.exports